import CoacheeSessionGroup from '@efdigital/ll-xceed-v2/components/coaching/coach/coachee-session-group.gts';
import type { CoachingCoachCoacheesCoacheeModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/coachees/coachee';
import type { TOC } from '@ember/component/template-only';

interface CoachingCoachCoacheesCoacheePastSignature {
  Args: {
    model: CoachingCoachCoacheesCoacheeModel;
    controller: unknown;
  };
}

<template>
  {{! Completed sessions waiting for an outcome report belong here with the
      rest of the past list. Untitled: the Past tab already names this view,
      and `summarizeCoacheeSessions` keeps them out of `history`, so nothing
      repeats. }}
  {{#if @model.summary.actionRequired.length}}
    <CoacheeSessionGroup
      @sessions={{@model.summary.actionRequired}}
      @coach={{@model.coach}}
      class="mb-4"
    />
  {{/if}}

  <CoacheeSessionGroup
    @sessions={{@model.summary.history}}
    @coach={{@model.coach}}
    {{! Suppressed while attention items are showing: "no past sessions" reads
        oddly directly beneath a list of them. }}
    @emptyMessage={{unless
      @model.summary.actionRequired.length
      "No past sessions with this coachee."
    }}
  />
</template> satisfies TOC<CoachingCoachCoacheesCoacheePastSignature>;
